import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { StyledP } from './DescriptionStyle'

const Description = ({ value, textColor, textMaxWidth, center, responsive }) => {
	const { t } = useTranslation()

	return (
		<StyledP center={center} textMaxWidth={textMaxWidth} textColor={textColor} responsive={responsive}>
			{t(value)}
		</StyledP>
	)
}

Description.propTypes = {
	value: PropTypes.string,
	textColor: PropTypes.string,
	center: PropTypes.bool
}
export default Description
